<template>
    <div class="moneysuccess">
        等待支付结果
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// waitmoney.vue?12c4c91e